import React, { useCallback, useEffect, useState } from 'react'
import { ReactComponent as ArrowIcon } from 'assets/icons/pointer-down.svg'
import s from './styles/UniversityKoda.module.scss'

const QUESTIONS = [
	'Can you refine this shortlist for scholarship chances?',
	'Which universities are safer with the current profile?',
	'How should we prioritize deadlines this month?',
	'What filter change would improve fit the most?',
]

function getScrollParent(node) {
	let current = node?.parentElement
	while (current) {
		const style = window.getComputedStyle(current)
		const overflowY = style.overflowY
		if (
			(overflowY === 'auto' || overflowY === 'scroll') &&
			current.scrollHeight > current.clientHeight
		) {
			return current
		}
		current = current.parentElement
	}
	return document.scrollingElement || document.documentElement
}

/**
 * Expand/collapse Koda strip under college filters (student KodaInstrument parity).
 * Auto-collapses on scroll unless the user manually toggled.
 */
export default function UniversityKoda({ isFetched = false, onQuestionClick }) {
	const [isExpanded, setIsExpanded] = useState(false)
	const [userToggled, setUserToggled] = useState(false)
	const [lastScrollTop, setLastScrollTop] = useState(0)
	const [rootEl, setRootEl] = useState(null)

	const toggleExpand = useCallback(() => {
		setIsExpanded(prev => !prev)
		setUserToggled(true)
	}, [])

	useEffect(() => {
		setIsExpanded(Boolean(isFetched))
	}, [isFetched])

	useEffect(() => {
		if (!rootEl) return undefined
		const body = getScrollParent(rootEl)
		if (!body) return undefined

		const handleScroll = () => {
			const scrollTop = body.scrollTop || 0

			if (
				!userToggled &&
				isExpanded &&
				Math.abs(scrollTop - lastScrollTop) > 10
			) {
				setIsExpanded(false)
			}

			if (scrollTop < 10) {
				setUserToggled(false)
			}

			setLastScrollTop(scrollTop)
		}

		body.addEventListener('scroll', handleScroll, { passive: true })
		return () => body.removeEventListener('scroll', handleScroll)
	}, [rootEl, isExpanded, userToggled, lastScrollTop])

	return (
		<section className={s.koda} ref={setRootEl}>
			<div className={s.head}>
				<div className={s.brand}>
					<div className={s.iconWrap}>
						<img
							src={require('assets/img/koda.png')}
							alt=""
							className={s.icon}
						/>
					</div>
					<h3 className={s.title}>Smart shortlist refining with Koda AI</h3>
				</div>
				<button
					type="button"
					className={`${s.toggle} ${isExpanded ? s.toggleExpanded : ''}`}
					aria-label={isExpanded ? 'Collapse Koda' : 'Expand Koda'}
					onClick={toggleExpand}
				>
					<ArrowIcon
						className={`${s.arrow} ${isExpanded ? s.arrowRotated : ''}`}
					/>
				</button>
			</div>
			<div
				className={`${s.content} ${isExpanded ? s.contentExpanded : ''}`}
			>
				<div className={s.contentInner}>
					{QUESTIONS.map(question => (
						<button
							key={question}
							type="button"
							className={s.question}
							onClick={() => {
								onQuestionClick?.(question)
								setIsExpanded(false)
							}}
						>
							{question}
						</button>
					))}
				</div>
			</div>
		</section>
	)
}
